import { actions } from 'react-redux-form';
import { batch } from 'react-redux';
import moment from 'moment';

import {
    getInvoiceDisputeComments,
    setInvoiceDisputeError,
} from "../../../../constants/model-reducers/external/invoice/dispute/dispute-comments.setting";
import { httpGet, httpPost, httpPostFile, httpDownload } from "../../../../utils/api.utils";
import { convertToLocalDateToUTCDate, getLocalTimeZone } from '../../../../utils/helpers.utils';

const defaultState = () => ({
    InvoiceDisputeComments: [],
});

const initialState = defaultState();

export const disputeCommentActions = {
    postInvoiceDisputeComments: (disputeID, filename, fileData, comment) => async (dispatch, state) => {

        var formData = new FormData();

        if (fileData.length > 0) {
            fileData.forEach((element) => formData.append("FileData", element));
            formData.append("FileName", JSON.stringify(filename));
        }

        formData.append("Comment", comment.toString());
        formData.append("UserId", parseInt(sessionStorage.getItem('UserID')),);
        formData.append("DisputeID", disputeID);

        var res = await httpPostFile('external/dispute/setInvoiceDisputeComments', formData);

        if (res != null) {
            dispatch({
                type: getInvoiceDisputeComments,
                InvoiceDisputeComments: res,
                isInvoiceDisputeLoaded: true,
                isInvoiceDisputeError: false
            });
        } else {
            dispatch({
                type: setInvoiceDisputeError,
                isInvoiceDisputeError: true,
                isInvoiceDisputeLoaded: false
            });
        }
    },

    getInvoiceDisputeComments: (disputeID) => async (dispatch, state) => {
        var res = await httpGet('external/dispute/getInvoiceDisputeComments?disputeID=' + disputeID + '&timeZone=' + getLocalTimeZone());

        if (res != null) {
            dispatch({
                type: getInvoiceDisputeComments,
                InvoiceDisputeComments: res,
                isInvoiceDisputeLoaded: true,
                isInvoiceDisputeError: false
            });
        } else {
            dispatch({
                type: setInvoiceDisputeError,
                isInvoiceDisputeError: true,
                isInvoiceDisputeLoaded: false
            });
        }
    },

    deleteInvoiceDisputeComments: (commentId) => async (dispatch, state) => {
        var userId = sessionStorage.getItem("UserID")
        var res = await httpPost('external/dispute/disputeDeleteComment/' + commentId + '/' + userId);

        if (res != null) {
            dispatch({
                type: getInvoiceDisputeComments,
                InvoiceDisputeComments: res,
                isInvoiceDisputeLoaded: true,
                isInvoiceDisputeError: false
            });
        } else {
            dispatch({
                type: setInvoiceDisputeError,
                isInvoiceDisputeError: true,
                isInvoiceDisputeLoaded: false
            });

        }
    },
}

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case getInvoiceDisputeComments: {
            return {
                ...state,
                InvoiceDisputeComments: action.InvoiceDisputeComments
            };
        }
        case setInvoiceDisputeError:{
            return {
                ...state,
                isInvoiceDisputeError: action.isInvoiceDisputeError,
                isInvoiceDisputeLoaded: action.isInvoiceDisputeLoaded
            }
        }
        default:
            return state;
    }
}